export enum FieldTypesEnum {
  date = 1,
  boolean,
  object,
  dateTime ,
}
